module.exports = __webpack_public_path__ + "static/key-themessenger-4a74006f498e147955a5369990491370.webp";